import { functions } from "../lib/firebaseApp";
import { httpsCallable } from "firebase/functions";

export const f_import_cow_array = httpsCallable(functions, 'import_cow_array');
export const f_recursive_delete = httpsCallable(functions, 'recursive_delete');
export const f_update_cows_param = httpsCallable(functions, 'update_cows_param');
export const f_delete_cows_param = httpsCallable(functions, 'delete_cows_param');

export const f_import_cowman_array = httpsCallable(functions, 'import_cowman_array2');

export const f_add_user = httpsCallable(functions, 'add_user');
export const f_update_user = httpsCallable(functions, 'update_user');
export const f_delete_user = httpsCallable(functions, 'delete_user');
export const f_set_user_claim = httpsCallable(functions, 'set_user_claim');
export const f_listAllUser = httpsCallable(functions, 'listAllUser');
export const f_getUserByEmail = httpsCallable(functions, 'getUserByEmail');
export const f_getUserById = httpsCallable(functions, 'getUserById');

export const f_import_property_array = httpsCallable(functions, 'import_property_array');
